import { utilTypes } from "../types";
const initialstate = {
  themes: [],
  spinner: false,
  drawerOpen: false,
  commonPageModalOpen: false,
  commonPageData: {},
  language: "gu",
  currentGramId: null,
  advertiseModalOpen: true,
};

const utilReducer = (state = initialstate, action) => {
  switch (action.type) {
    case utilTypes.GET_ALL_THEMES_SUCCESS:
      return {
        ...state,
        themes: action.payload.data.data || [],
      };

    case utilTypes.TOGGLE_DRAWER:
      return {
        ...state,
        drawerOpen: !state.drawerOpen,
      };

    case utilTypes.TOGGLE_ADVERTISEMENT:
      return {
        ...state,
        advertiseModalOpen: !state.advertiseModalOpen,
      };

    case utilTypes.OPEN_COMMON_PAGE_MODAL:
      return {
        ...state,
        commonPageModalOpen: true,
        commonPageData: action.payload,
      };

    case utilTypes.CLOSE_COMMON_PAGE_MODAL:
      return {
        ...state,
        commonPageModalOpen: false,
        commonPageData: undefined,
      };

    case utilTypes.SET_CURRENT_GRAM:
      return {
        ...state,
        currentGramId: action.payload,
      };

    case "SPINNER_START":
      return {
        ...state,
        spinner: true,
      };

    case "SPINNER_STOP":
      return {
        ...state,
        spinner: false,
      };

    default:
      return state;
  }
};

export default utilReducer;
